import React from 'react';
import Can from '~/contexts/Can';
import NotPermissionPage from '~/pages/NotPermissionPage';
import AppointmentConfirmations from './AppointmentConfirmations';
import { AppointmentConfirmationProvider } from './context';

function AppointmentConfirmationsPage() {
  return (
    <AppointmentConfirmationProvider>
      <Can I="edit" a="AppointmentConfirmations">
        {() => <AppointmentConfirmations />}
      </Can>
      <Can not I="edit" a="AppointmentConfirmations">
        {() => <NotPermissionPage />}
      </Can>
    </AppointmentConfirmationProvider>
  );
}

export default AppointmentConfirmationsPage;
